import { createReducer, on } from '@ngrx/store';
import { initialState } from './new-accounts.state';
import {
  newAccountPageActions,
  newAccountPageAPIActions,
  newBulkAccountAPIActions,
  newBulkAccountPageActions,
  previousBulkImportsAPIActions,
  previousBulkImportsPageActions,
  previousImportAPIActions,
  previousImportPageActions
} from './new-accounts.actions';

export const newAccountReducer = createReducer(
  initialState,

  on(newAccountPageActions.userSubmittedNewAccount, (state) => ({
    ...state,
    newAccount: {
      ...state.newAccount,
      submitting: true
    }
  })),

  on(newAccountPageAPIActions.createNewAccountSuccess, newAccountPageAPIActions.createNewAccountFailure, (state) => {
    return {
      ...state,
      newAccount: {
        ...state.newAccount,
        submitting: false
      }
    };
  }),

  on(newBulkAccountPageActions.userSubmittedBulkAccount, (state) => ({
    ...state,
    bulkAccount: {
      ...state.bulkAccount,
      submitting: true
    }
  })),

  on(newBulkAccountAPIActions.createBulkAccountFailure, (state) => ({
    ...state,
    bulkAccount: {
      ...state.bulkAccount,
      submitting: false
    }
  })),

  on(newBulkAccountAPIActions.statusPending, (state, { status }) => ({
    ...state,
    bulkAccount: {
      ...state.bulkAccount,
      status: status
    }
  })),

  on(newBulkAccountAPIActions.statusSuccess, (state, { status }) => ({
    ...state,
    bulkAccount: {
      ...state.bulkAccount,
      status: status,
      submitting: false
    }
  })),

  on(previousBulkImportsPageActions.userRequestedPreviousImports, (state) => ({
    ...state,
    previousImports: {
      ...initialState.previousImports,
      loading: true
    }
  })),

  on(previousBulkImportsAPIActions.getPreviousImportsSuccess, (state, { previousImports, totalCount }) => ({
    ...state,
    previousImports: {
      ...state.previousImports,
      items: previousImports,
      totalCount: totalCount,
      loading: false
    }
  })),

  on(previousBulkImportsPageActions.userRequestedMorePreviousImports, (state) => ({
    ...state,
    previousImports: {
      ...state.previousImports,
      pageSize: state.previousImports.pageSize + 20
    }
  })),

  on(previousImportPageActions.userRequestedPreviousImportDetail, (state, { eventId }) => ({
    ...state,
    previousImports: {
      ...state.previousImports,
      selectedPreviousImport: {
        ...initialState.previousImports.selectedPreviousImport,
        id: eventId
      }
    }
  })),

  on(previousImportAPIActions.getPreviousImportDetailSuccess, (state, { previousImportDetail }) => ({
    ...state,
    previousImports: {
      ...state.previousImports,
      selectedPreviousImport: {
        ...state.previousImports.selectedPreviousImport,
        ...previousImportDetail,
        loading: false
      }
    }
  })),

  on(previousImportPageActions.userRequestedMorePreviousImportDetails, (state) => ({
    ...state,
    previousImports: {
      ...state.previousImports,
      selectedPreviousImport: {
        ...state.previousImports.selectedPreviousImport,
        pageSize: state.previousImports.pageSize + 40
      }
    }
  }))
);
